import React from 'react';
import { serverUrl } from '../../appconst';
import { isAdmin, verifyAuth } from '../../authverify';
import './usermanagement.css';

class UserManagement extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      users: [],
      rows: [],
      isFetched: false
    };

    if (!verifyAuth() || !isAdmin) {
      this.props.history.push({
        pathname: '/',
      });
    }
    
  }

  componentDidMount () {
    
    fetch(serverUrl+'/api/get/users', {
    method: 'GET',
    headers: {
      'x-access-token': (JSON.parse(window.sessionStorage.getItem("usersession"))).accessToken, 
      'Content-Type': 'application/json'
    },
  })
  .then(res => res.json())
  .then((data) => {
    if(data.message === "No record found or encountered error"){
      alert(data.message);
      return ;
    }
    else{
     // return JSON.stringify(data.users);
     this.state.users = data.users;
     this.state.isFetched = true;
     this.createUserRows();
    }
  })
  .catch(console.log);
}


delete = (data) => {
  if(data){
  fetch(serverUrl+'/api/delete/user/'+data, {
    method: 'DELETE',
    headers: {
      'x-access-token': (JSON.parse(window.sessionStorage.getItem("usersession"))).accessToken, 
      'Content-Type': 'application/json'
    },
  })
  .then(res => res.json())
  .then((data) => {
    if(data.error === "No user"){
      alert(data.error);
      return ;
    }
    else{
      alert('Reload')
    }
  })
  .catch(console.log);
  window.location.reload(true);
}
}

  createUserRows = () => {
    if(this.state.users && this.state.isFetched){
         this.state.users.forEach((element) => {
           if(element.role !== 'Admin'){
          this.state.rows.push(
            <React.Fragment>
                <div class="grid-item">{element.id}</div>
                <div class="grid-item">{element.fullname}</div>
                <div class="grid-item">{element.email}</div>  
                <div class="grid-item">{element.designation}</div>
                <div class="grid-item">{element.company}</div>
                <div class="grid-item">{element.country}</div>   
                <div class="grid-item"><button onClick={() => this.delete(element.id)}>Delete</button></div>  
            </React.Fragment>
          );
        }
        });
       // console.log("----------------> "+this.state.users)
       this.forceUpdate();
    }
    
  }

  render() {
    return (
     <>
      <h1>User Management</h1>

<div class="grid-container">
  <div class="grid-item">ID</div>
  <div class="grid-item">Full Name</div>
  <div class="grid-item">Email</div>  
  <div class="grid-item">Designation</div>
  <div class="grid-item">Company</div>
  <div class="grid-item">Country</div>  
  <div class="grid-item">Delete</div>  
  {this.state.rows.map((name) => name)}
</div>
     </>
    );
  }
}

export default UserManagement;
